import { RootState } from '@app/store/types';

export const getSoftLandingStatus = (state: RootState) => state.softLanding.status;

export const getSoftLandingCountOfDocuments = (state: RootState) =>
  state.softLanding.countOfDocuments;
